export const Tag = `
    const onTagClick = (selectedTag: number | string)=>{
        console.info(selectedTag)
    }

    <Tag
        color="default" // String: default, neutral, info, warning, danger, success, primary
        label="Tag label" // String: any
        borderRadius="full"  // String: full, l, r
        value="tag-value" // String || Number
        onClick={handleClick}  // Function
        iconLeft={<IconAward size="sm"/>}  // ReactNode
        iconRight={<IconAward size="sm"/>} // ReactNode
        variant="solid"  // String: solid, subtle, outline
    />
`
